import React, {useState, useEffect, useCallback} from 'react'
/* --------------------------------------------- */
/* --------------------------------------------- */
import { ImgContainer, InfoTitle, InfoDesc } from './styles'
import "./_landing-page.scss";

/* --------------------------------------------- */
// LandingFeature component for showing pageComponent
const LandingFeature = (props) => {
  // const { graphics } = theme
  // const [theme, updateTheme] = useState(null)
  const {landingFeature, themeSection:theme = {}} = props
  const {graphics:[imagesData = {}] = [],body = {}} = theme
  const {images:backgroundImages = []} = imagesData
  const {background = {}} = body
  const [bgImage, updatebgImage] = useState(background?.primary || null)
  // const { appTheme } = useSelector(store => store.themeConfigReducers)

  let resizeWindow = useCallback(() => {
    if (window.innerWidth < 650) {
      updatebgImage(backgroundImages[1]?.url)
    } else if (window.innerWidth > 650) {
      updatebgImage(backgroundImages[0]?.url)
    }
  },[updatebgImage,backgroundImages]);

  useEffect(() => {
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);
  }, [resizeWindow]);


  /**
   * It: Updates theme.
   */
  // useEffect(() => {
  //   updateTheme(appTheme)
  // }, [appTheme])
  return (
    <>
      <ImgContainer {...{ images: bgImage }} >
        <div className='landing-feature' style={{backgroundColor:background?.primary}}>
          {
            landingFeature.map((feature, index) => {
              return (
                <div className="feature-container" key={index}>
                {
                  feature.graphics && <img src={feature.graphics} className='feature-img' alt="feature-img"/>
                }
                {
                  feature.title && (
                    <InfoTitle {...{ theme }} className='featureSection__title'>{feature.title}</InfoTitle>
                  )
                }
                {
                  feature.description && (
                    <InfoDesc {...{ theme }} className='featureSection__desc'>{feature.description}</InfoDesc>
                  )
                }
                </div>
              )
            })
          }
        </div>
      </ImgContainer>
    </>
  )
}


/* --------------------------------------------- */
LandingFeature.propTypes = {

}
/* --------------------------------------------- */
LandingFeature.defaultProps = {

}
/* --------------------------------------------- */
export default LandingFeature
